<template>
    <div class="flex flex-col border border-gray-200 rounded-xl divide-y divide-gray-200">
        <div v-for="boolean in booleans" :key="boolean.label" class="flex-1 flex items-center px-4 py-2">
            <span class="fa-stack">
                <i class="fas fa-circle fa-stack-2x" :class="boolean.value ? 'text-green-100' : 'text-red-100'"></i>
                <i class="fas fa-stack-1x" :class="boolean.value ? 'fa-check text-green-600' : 'fa-times text-red-500'"></i>
            </span>
            <div class="leading-tight ml-3">
                <div class="font-semibold">{{ boolean.label }}</div>
                <div :class="boolean.value ? 'text-green-700' : 'text-red-700'">{{ boolean.value | human_bool }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        booleans: Array,
    },
}
</script>
